
const _ = require('lodash');


module.exports = _.extend(...[
	{},
	require('./js/address.js'),
	require('./js/address-validatable.js'),
]);

